import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';

const DEV_PORTAL_HOSTNAME = 'developer-portal.dev.sodexonet.com';

export function initializeDatadogRum(
  hostname = window.location.hostname,
): void {
  // Feature branches deploy to Sandbox first. Only collect RUM from the
  // monitored SDX DEV portal so Sandbox traffic is not labelled as DEV.
  if (hostname !== DEV_PORTAL_HOSTNAME) {
    return;
  }

  datadogRum.init({
    applicationId: '72a60a59-c240-4e10-8761-da1cc94e28ac',
    clientToken: 'pub0a8fd6133ccafc2f40323dea9e335870',
    site: 'datadoghq.eu',
    service: 'backstage',
    env: 'dev',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    trackResources: true,
    trackUserInteractions: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    plugins: [reactPlugin({ router: false })],
  });

  datadogRum.setGlobalContext({
    app: 'developer-portal',
    team: 'data-factory-developer-platform',
  });
}
